
import http from '@/http';

const mixins = {

    methods:{
        slectedCompany(selected){
            
            if(selected){
              this.params.company = selected;
            }
        },
        slectedCustomer(selected){
            
            if(selected){
              this.params.customer = selected;
            }
        },
        changeCompany(item){
    
            if(item == ""){
              return item;
            }
           
            return  http.get("/adm/company",{ params: {name:item} }).then((response)=>{
              
              this.companys = response.data;
              return response;
               
              }).catch( err =>{
                  window.console.log("error",err);
            });
    
        },
        changeCustomer(item){
    
            if(item == ""){
              return item;
            }
    
    
            var id_company = ""
    
            if(this.params.company.id != undefined){
              id_company = this.params.company.id
            }
           
            return  http.get("/adm/customer",{ params: {name:item,id_company} }).then((response)=>{
              
              this.customers = response.data.map(item=>{
    
                item.name = `${item.id} - ${item.name}`
                return item;
              });
              return response;
               
              }).catch( err =>{
                  window.console.log("error",err);
            });
    
        },        
        clearSearch(){
            this.params = {};
            this.$emit("search",this.params)
        }
    }

}

export default mixins